import { useCallback } from 'react';
import styled from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { BlankIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledRow = styled.li.withConfig({
  displayName: "EPSpotlightSuggestion__StyledRow",
  componentId: "cvit5p-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    borderRadius: theme.borderRadius['200'],
    height: theme.space['1000'],
    cursor: 'pointer',
    display: 'flex',
    '&:hover, &[aria-selected="true"]': {
      backgroundColor: theme.color['fill-secondary-hover']
    }
  };
});
export const EPSpotlightSuggestion = ({
  isSelected,
  onClick,
  suggestion
}) => {
  const {
    icon,
    label
  } = suggestion;
  const handleClick = useCallback(() => {
    onClick(suggestion);
  }, [onClick, suggestion]);
  const Icon = icon !== null && icon !== void 0 ? icon : BlankIcon;
  return /*#__PURE__*/_jsx(StyledRow, {
    "aria-selected": isSelected,
    onClick: handleClick,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexGrow: 1,
      paddingInline: "400",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: Icon,
        color: "icon-core-subtle",
        size: "400",
        padding: "0",
        marginInlineEnd: "200"
      }), /*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "0",
        children: label
      })]
    })
  });
};
export default EPSpotlightSuggestion;